
import { useState } from "react";
import { motion } from "framer-motion";

import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import Counter from "@/modules/frontend/components/Counter";
import RegistrationSteps from "@/modules/frontend/components/RegistrationSteps";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { ToastContainer } from "react-toastify";
import partnerWithUs from "@/assets/images/webp/join-logistic-img.webp";
import globalConnection from "@/assets/images/webp/global-connections.webp";
import boostedSearch from "@/assets/images/webp/boosted-search-visibility.webp";
import digitalReach from "@/assets/images/webp/Digital-Reach.webp";
import VerifiedLeads from "@/assets/images/webp/verified-leads.webp";
import marketInsight from "@/assets/images/webp/market-insights-worldwide.webp";
import financialProtection from "@/assets/images/webp/financial-protection-icon.webp";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { Link } from "react-router-dom";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  return (
    <>
      {/* inner banner wrape START  */}
      <section className="inner-banner logistic-page">
        <SeoHelmet
          title={seoConfig.logistics.title}
          description={seoConfig.logistics.description}
          keywords={seoConfig.logistics.keywords}
          author={seoConfig.logistics.author}
        />
        <button
          className="btn outline small sticky-btn"
          onClick={handleQuoteClick}
          type="button"
        >
          Book A Demo
        </button>
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              <motion.span className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Seamless</motion.span>
              <motion.span className="blue-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Deliveries.</motion.span>
              <motion.span className="black animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Global Opportunities.</motion.span>
            </h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Become a trusted logistics partner on Orex Trade and access a growing community of businesses seeking reliable trade solutions</motion.p>
          </div>
        </div>
      </section>
      {/* inner banner wrape END  */}

      {/* why partner wrape START  */}
      <section className="why-partner-section inner-page-content-wrape">
        <div className="container">
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              <motion.span className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Seamless</motion.span>
              <motion.span className="blue-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Deliveries.</motion.span>
              <motion.span className="black animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              > Global Opportunities.</motion.span>
            </h2>
            <motion.p className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Become a trusted logistics partner on Orex Trade and access a growing community of businesses seeking reliable trade solutions</motion.p>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
              <div className="img-wrape">
                <Link to={publicRoutePaths.REGISTRATION.path} href={publicRoutePaths.REGISTRATION.path} target="_blank">
                  <motion.img src={partnerWithUs} alt="partner-with-orex" loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </Link>

              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
              <div className="head-text">
                <motion.h2 className="head animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >Why Partner With Us?</motion.h2>
              </div>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >At Orex Trade World INC, we recognize that logistics is the backbone of global trade. By partnering with us, you gain access to a trusted network of buyers and suppliers who are constantly in need of reliable shipping and transportation solutions. </motion.p>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >Our network connects you with businesses across 80+ countries, various ports and gives you the opportunity to expand your reach, increase visibility and grow your client base. Together, we make international trade simpler, faster and more efficient while building long-term partnerships based on trust and value.</motion.p>

              <div className="statistics-wrape-benefit">
                <div className="statistics-content">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span><Counter end={750} duration={2} suffix="+" /> Global</span>
                    <p>
                      Logistics Partners
                    </p>
                  </motion.div>
                </div>
                <div className="statistics-content big">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span>
                      <Counter end={100} duration={2} suffix="K" /> Up to
                    </span>
                    <p>
                      Financial Protection
                    </p>
                  </motion.div>
                </div>
                <div className="statistics-content">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span><Counter end={80} duration={2} suffix="+" /> Countries</span>
                    <p>
                      Globally Serve
                    </p>
                  </motion.div>
                </div>
                <div className="statistics-content big">
                  <motion.div className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >
                    <span><Counter end={350} duration={2} suffix="+" /> Worldwide</span>
                    <p>
                      Cities & Ports Covered
                    </p>
                  </motion.div>
                </div>
                <motion.div className="button-wrape animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  custom={0.2}
                  variants={fadeUpVariant}
                >
                  <Link className="btn outline" to={publicRoutePaths.REGISTRATION.path} target="_blank" href={publicRoutePaths.REGISTRATION.path}>
                    Become a Partner
                    <span className="round">
                      <i className="sprite"></i>
                    </span>
                  </Link>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* why partner wrape END */}

      {/* benefit partnering wrape START  */}
      <section className="benefit-partnering-wrape">
        <div className="head-text center container medium">
          <motion.h2 className="head center animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          >Benefits of Partnering With Orex Trade</motion.h2>
          <motion.p
            className="animate-child"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            custom={0.2}
            variants={fadeUpVariant}
          >Streamline your supply chain and unlock new opportunities through seamless, timely and secure logistics solutions</motion.p>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={globalConnection} alt="Global Connections" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Global Connections</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Access a community of genuine, verified businesses ready to trade. Build strong partnerships that drive growth and trust</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={boostedSearch} alt="Boosted Search Visibility" loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Boosted Search Visibility</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Get premium visibility with Orex Trade. Your profile ranks on top, helping buyers and suppliers find your products first</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={digitalReach} alt="Digital Reach" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Digital Reach</motion.h6>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Reach the right audience with impactful digital and social media campaigns designed to grow your brand globally</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={VerifiedLeads} alt="Verified Leads" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Verified Leads</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Simplify the way you request and receive quotes with our easy-to-use system-fast, accurate and hassle-free</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={marketInsight} alt="Market Insights Worldwide" loading="lazy" className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Market Insights Worldwide</motion.h6>
                  <motion.p className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Unlock actionable insights from 80+ countries to guide your strategies, expand reach and stay ahead of competition</motion.p>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12">
              <div className="benefit-pad">
                <div className="icon">
                  <motion.img src={financialProtection} alt="Financial Protection" loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
                <div className="detail">
                  <motion.h6 className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Financial Protection</motion.h6>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    custom={0.2}
                    variants={fadeUpVariant}
                  >Ensure secure and risk-free transactions with trusted financial safeguards, giving your business confidence in every deal</motion.p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* benefit partnering wrape END  */}

      {/* stepper wrape START  */}
      <RegistrationSteps pageName="logistic" sectionTitle="All you have to do is follow these simple steps" subTitle="Follow this guided process to set up your account and begin trading confidently" />
      {/* stepper wrape END  */}
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  )
}

export default Index;